import { render, staticRenderFns } from "./BiNavbar.vue?vue&type=template&id=015fe926&scoped=true"
import script from "./BiNavbar.vue?vue&type=script&lang=js"
export * from "./BiNavbar.vue?vue&type=script&lang=js"
import style0 from "./BiNavbar.vue?vue&type=style&index=0&id=015fe926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015fe926",
  null
  
)

export default component.exports